/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
// Not sure where using this.
const STATUSES = [
  'Requested',
  'Approved',
  'Wait Callback',
  'Picked and Packed',
  'Reached',
  'Unreach',
  'Out for Delivery',
  'Failed to Deliver',
  'Rejected',
  'Cancelled',
  'Returned',
];

export const DELIVERY_ORDER_STATUS = {
  INVALID: 'Invalid',
  REQUESTED: 'Requested',
  RECONTACT: 'Recontact',
  HOLD: 'Hold',
  TO_BE_RETURN: 'To be return',
  APPOINTED: 'Appointed',
  OUT_FOR_DELIVERY: 'Out for delivery',
  FAIL_TO_DELIVER: 'Fail to deliver',
  DELIVERED: 'Delivered',
  RETURN: 'Return',
  PENDING: 'Pending',
};

export const PENDING_STATUS = {
  label: 'Pending',
  value: 'Pending',
};

export const INVALID_STATUS = {
  label: 'Invalid',
  value: 'Invalid',
};

export const FAILED_TO_DELIVER = 'Failed to deliver';

export const failedOptions = [
  {
    value: 'ARRIVED',
    label: 'Arrived',
  },{
    value: 'BEFORE_ARRIVED',
    label: 'Before arrived',
  },
]

export const failedToOptions = [
  {
    label: "Appointed",
    value: "Appointed",
  },
  {
    label: "Recontact",
    value: "Recontact",
  },
  {
    label: "To be return",
    value: "To be return"
  }
]

export const FAILED_CONDITION = {
  ARRIVED: {
    value: 'ARRIVED',
    label: 'Arrived',
  },
  BEFORE_ARRIVED: {
    value: 'BEFORE_ARRIVED',
    label: 'Before arrived',
  },
};

export const DELIVERY_ORDER_PAYMENT_OPTIONS = {
  CASE_ON_DELIVERY: {
    label: 'Cash on Delivery',
    value: 'cashOnDelivery',
  },
  TRANSFER: {
    label: 'Transfer',
    value: 'transfer',
  },
  PATIALLY_PAID: {
    label: 'Patially Paid',
    value: 'patiallyPaid',
  },
  FULLY_PAID: {
    label: 'Fully Paid',
    value: 'fullyPaid',
  },
};

const INVOICES_TYPE = {
  DELIVERED: 'delivered',
  RETURN: 'return'
};

export const invoiceTypeOptions = [
  { value: 'delivered', label: 'Delivered' },
  { value: 'return', label: 'Return' },
];


export const paymentOptions = [
  DELIVERY_ORDER_PAYMENT_OPTIONS.CASE_ON_DELIVERY,
  DELIVERY_ORDER_PAYMENT_OPTIONS.TRANSFER,
  DELIVERY_ORDER_PAYMENT_OPTIONS.PATIALLY_PAID,
  DELIVERY_ORDER_PAYMENT_OPTIONS.FULLY_PAID,
];

export const paymentCreateOptions = [
  DELIVERY_ORDER_PAYMENT_OPTIONS.CASE_ON_DELIVERY,
  DELIVERY_ORDER_PAYMENT_OPTIONS.FULLY_PAID,
];

export const serviceTypeOptions = [
  {
    label: 'Delivered',
    value: 'delivered',
  },
  {
    label: 'Return',
    value: 'return',
  }
];

export const statusFilterOptions = [
  {
    label: DELIVERY_ORDER_STATUS.REQUESTED,
    value: DELIVERY_ORDER_STATUS.REQUESTED,
  },
  {
    label: DELIVERY_ORDER_STATUS.APPOINTED,
    value: DELIVERY_ORDER_STATUS.APPOINTED,
  },
  {
    label: DELIVERY_ORDER_STATUS.RECONTACT,
    value: DELIVERY_ORDER_STATUS.RECONTACT,
  },
  {
    label: DELIVERY_ORDER_STATUS.HOLD,
    value: DELIVERY_ORDER_STATUS.HOLD,
  },
  {
    label: DELIVERY_ORDER_STATUS.TO_BE_RETURN,
    value: DELIVERY_ORDER_STATUS.TO_BE_RETURN,
  },
  {
    label: DELIVERY_ORDER_STATUS.RETURN,
    value: DELIVERY_ORDER_STATUS.RETURN,
  },
  {
    label: DELIVERY_ORDER_STATUS.OUT_FOR_DELIVERY,
    value: DELIVERY_ORDER_STATUS.OUT_FOR_DELIVERY,
  },
  {
    label: DELIVERY_ORDER_STATUS.FAIL_TO_DELIVER,
    value: DELIVERY_ORDER_STATUS.FAIL_TO_DELIVER,
  },
  {
    label: DELIVERY_ORDER_STATUS.DELIVERED,
    value: DELIVERY_ORDER_STATUS.DELIVERED,
  },
  {
    label: DELIVERY_ORDER_STATUS.PENDING,
    value: DELIVERY_ORDER_STATUS.PENDING,
  },
  {
    label: DELIVERY_ORDER_STATUS.INVALID,
    value: DELIVERY_ORDER_STATUS.INVALID,
  },
]

export const pendingStatusOptions = [
  {
    label: PENDING_STATUS.label,
    value: PENDING_STATUS.value,
  },
]

export const invalidStatusOptions = [
  {
    label: INVALID_STATUS.label,
    value: INVALID_STATUS.value,
  },
]

export const statusOptions = [
  {
    label: DELIVERY_ORDER_STATUS.REQUESTED,
    value: DELIVERY_ORDER_STATUS.REQUESTED,
  },
  {
    label: DELIVERY_ORDER_STATUS.APPOINTED,
    value: DELIVERY_ORDER_STATUS.APPOINTED,
  },
  {
    label: DELIVERY_ORDER_STATUS.RECONTACT,
    value: DELIVERY_ORDER_STATUS.RECONTACT,
  },
  // {
  //   label: DELIVERY_ORDER_STATUS.DELIVERED,
  //   value: DELIVERY_ORDER_STATUS.DELIVERED,
  // },
  {
    label: DELIVERY_ORDER_STATUS.HOLD,
    value: DELIVERY_ORDER_STATUS.HOLD,
  },
  {
    label: DELIVERY_ORDER_STATUS.TO_BE_RETURN,
    value: DELIVERY_ORDER_STATUS.TO_BE_RETURN,
  },
  {
    label: DELIVERY_ORDER_STATUS.RETURN,
    value: DELIVERY_ORDER_STATUS.RETURN,
  },
];

export const statusOptionsDelivered = [
  {
    label: DELIVERY_ORDER_STATUS.RETURN,
    value: DELIVERY_ORDER_STATUS.RETURN,
  },
];

export const readOnlyStatus = [
  {
    label: DELIVERY_ORDER_STATUS.OUT_FOR_DELIVERY,
    value: DELIVERY_ORDER_STATUS.OUT_FOR_DELIVERY,
  },
  {
    label: DELIVERY_ORDER_STATUS.FAIL_TO_DELIVER,
    value: DELIVERY_ORDER_STATUS.FAIL_TO_DELIVER,
  },
  {
    label: DELIVERY_ORDER_STATUS.DELIVERED,
    value: DELIVERY_ORDER_STATUS.DELIVERED,
  },
];

export const transferLocationOptions = [
  {
    label: 'Phnom Penh',
    value: 'Phnom Penh',
  },
  {
    label: 'Province',
    value: 'Province',
  },
];
export const provinceVehicleOption = [
  {
    label: 'Taxi',
    value: 'taxi',
  },
  {
    label: 'Bus',
    value: 'bus',
  },
];

export const transferOption = [
  {
    label: 'Bus',
    value: 'bus',
  },
  {
    label: 'Taxi',
    value: 'taxi',
  },
];

export const TRANSFER_OPTIONS = {
  BUS: 'bus',
  TAXI: 'taxi',
};



export const transferMethodOptions = [
  {
    label: 'Wing',
    value: 'Wing',
  },
  {
    label: 'True Money',
    value: 'True Money',
  },
  {
    label: 'eMoney',
    value: 'eMoney',
  },
  {
    label: 'SmartLuy',
    value: 'SmartLuy',
  },
  {
    label: 'ABA Bank',
    value: 'ABA Bank',
  },
  {
    label: 'Taxi',
    value: 'Taxi',
  },
];

export const shiftOptions = [
  {
    label: 'Morning',
    value: 'Morning',
  },
  {
    label: 'Afternoon',
    value: 'Afternoon',
  },
  {
    label: 'Other',
    value: 'Other',
  }
]

export const brandOptions = [
  {
    label: 'BKK',
    value: 'BKK',
  },
  {
    label: 'TK',
    value: 'TK',
  },
  {
    label: 'Sensok',
    value: 'Sensok',
  },
  {
    label: 'Siem Reap',
    value: 'Siem Reap',
  }
]

export const areaOptions = [
  {
    value: "Phsa Ches",
    label: "Phsa Ches"
  },
  {
    value: "Koh Pich",
    label: "Koh Pich"
  },
  {
    value: "Veng Sreng",
    label: "Veng Sreng"
  },
  {
    value: "Chomka Dong",
    label: "Chomka Dong"
  },
  {
    value: "Street 2004",
    label: "Street 2004"
  },
  {
    value: "Chom Chao",
    label: "Chom Chao"
  },
  {
    value: "Tek Tla",
    label: "Tek Tla"
  },{
    value: "Phsa Dey Huy",
    label: "Phsa Dey Huy"
  },
  {
    value: "Aeon 2",
    label: "Aeon 2"
  },
  {
    value: "Toul Kork",
    label: "Toul Kork"
  },
  {
    value: "Chroy Jongva",
    label: "Chroy Jongva"
  },
  {
    value: "Toul Songkae",
    label: "Toul Songkae"
  },{
    value: "Ouressey",
    label: "Ouressey"
  },{
    value: "Somnong 12",
    label: "Somnong 12"
  },
  {
    value: "Province",
    label: "Province"
  },{
    value: "Beoung Keng Kong",
    label: "Beoung Keng Kong"
  },{
    value: "Toul Tompong",
    label: "Toul Tompong"
  },{
    value: "Ta Kmao",
    label: "Ta Kmao"
  },{
    value: "Chbar Ompov",
    label: "Chbar Ompov"
  },
  {
    value: "In City",
    label: "In City"
  },
]

export const merchantCategoryOptions = [
  {
    label: "Fashion Shop",
    value: "Fashion Shop"
  },
  {
    label: "Online Shop",
    value: "Online Shop"
  }
];

export const roleOptions = [
  {
    label: "Driver",
    value: "DRIVER"
  },
  {
    label: "Merchant",
    value: "SENDER"
  },
  {
    label: "Call Center",
    value: "CALL_CENTER"
  },
  {
    label: "Customer Service",
    value: "CUSTOMER_SERVICE"
  },
  {
    label: "Operation",
    value: "OPERATION"
  },
  {
    label: "Account",
    value: "ACCOUNT"
  },
  {
    label: "Admin",
    value: "ADMIN"
  },
  {
    label: "Super Admin",
    value: "SUPER_ADMIN"
  }

];

export const sangkatOptions = [
  {
    name: 'Phnom Penh Thmei',
    code: '12101',
  },
  {
    name: 'Teuk Thlar',
    code: '12102',
  },
  {
    name: 'Khmounh',
    code: '12103',
  },
  {
    name: 'Russei Keo',
    code: '12104',
  },
  {
    name: 'Toul Sang Ke',
    code: '12105',
  },
  {
    name: 'Kilometre 6',
    code: '12106',
  },
  {
    name: 'Chrang Chamres 1',
    code: '12107',
  },
  {
    name: 'Chrang Chamres 2',
    code: '12108',
  },
  {
    name: 'Svay Pak',
    code: '12109',
  },
  {
    name: 'Chroy Changva',
    code: '12110',
  },
  {
    name: 'Prek Tasek',
    code: '12111',
  },
  {
    name: 'Prek Leap',
    code: '12112',
  },
  //
  {
    name: 'Boeungkak 1',
    code: '12151',
  },
  {
    name: 'Boeungkak 2',
    code: '12152',
  },
  {
    name: 'Phsardepo 1',
    code: '12153',
  },
  {
    name: 'Phsardepo 2',
    code: '12154',
  },
  {
    name: 'Phsardepo 3',
    code: '12155',
  },
  {
    name: 'Teuk Laak 1',
    code: '12156',
  },
  {
    name: 'Teuk Laak 2',
    code: '12157',
  },
  {
    name: 'Teuk Laak 3',
    code: '12158',
  },
  {
    name: 'Phsar Doeumkor',
    code: '12159',
  },
  {
    name: 'Boeungsalang',
    code: '12160',
  },
  //
  {
    name: 'Sraas Chak',
    code: '12201',
  },
  {
    name: 'Wat Phnom',
    code: '12202',
  },
  {
    name: 'Phsar Chas',
    code: '12203',
  },
  {
    name: 'Phsar Kandal 1',
    code: '12204',
  },
  {
    name: 'Phsar Kandal 2',
    code: '12205',
  },
  {
    name: 'Chey Chumneas',
    code: '12206',
  },
  {
    name: 'Chak Tomuk',
    code: '12207',
  },
  {
    name: 'Phsar Thmei 1',
    code: '12208',
  },
  {
    name: 'Phsar Thmei 2',
    code: '12209',
  },
  {
    name: 'Phsar Thmei 3',
    code: '12210',
  },
  {
    name: 'Boeung Raing',
    code: '12211',
  },
  //
  {
    name: 'Monorom',
    code: '12251',
  },
  {
    name: 'Mittapheap',
    code: '12252',
  },
  {
    name: 'Veal Vong',
    code: '12253',
  },
  {
    name: 'Orussei 1',
    code: '12254',
  },
  {
    name: 'Orussei 2',
    code: '12255',
  },
  {
    name: 'Orussei 3',
    code: '12256',
  },
  {
    name: 'Orussei 4',
    code: '12257',
  },
  {
    name: 'Boeung Prolit',
    code: '12258',
  },
  //
  {
    name: 'Tonle Basak',
    code: '12301',
  },
  {
    name: 'Boeungkengkang 1',
    code: '12302',
  },
  {
    name: 'Boeungkengkang 2',
    code: '12303',
  },
  {
    name: 'Boeungkengkang 3',
    code: '12304',
  },
  {
    name: 'Boeung Trabek',
    code: '12305',
  },
  {
    name: 'Tumnup Teuk',
    code: '12306',
  },
  {
    name: 'Phsar Doeum Thkov',
    code: '12307',
  },
  {
    name: 'Toul Svay Prey 1',
    code: '12308',
  },
  {
    name: 'Toul Svay Prey 2',
    code: '12309',
  },
  {
    name: 'Toul Tum Poung 1',
    code: '12310',
  },
  {
    name: 'Toul Tum Poung 2',
    code: '12311',
  },
  {
    name: 'Olympic',
    code: '12312',
  },
  //
  {
    name: 'Boeung Tumpun',
    code: '12351',
  },
  {
    name: 'Steung Meanchey',
    code: '12352',
  },
  {
    name: 'Chak Angre Krom',
    code: '12353',
  },
  {
    name: 'Chak Angre Leu',
    code: '12354',
  },
  {
    name: 'Chbar Ampeou 1',
    code: '12355',
  },
  {
    name: 'Chbar Ampeou 2',
    code: '12356',
  },
  {
    name: 'Niroth',
    code: '12357',
  },
  {
    name: 'Prek Pra',
    code: '12358',
  },
  //
  {
    name: 'Dang Kor',
    code: '12401',
  },
  {
    name: 'Trapeang Krasaing',
    code: '12402',
  },
  {
    name: 'Kokroka',
    code: '12403',
  },
  {
    name: 'Phleung Chhesrotes',
    code: '12404',
  },
  {
    name: 'Chom Chao',
    code: '12405',
  },
  {
    name: 'Kakap',
    code: '12406',
  },
  {
    name: 'Porng Teuk',
    code: '12407',
  },
  {
    name: 'Prey Veng',
    code: '12408',
  },
  {
    name: 'Samrong',
    code: '12409',
  },
  {
    name: 'Prey Sar',
    code: '12410',
  },
  {
    name: 'Kraing Thnoung',
    code: '12411',
  },
  {
    name: 'Kraing Pongro',
    code: '12412',
  },
  {
    name: 'Prataslang',
    code: '12413',
  },
  {
    name: 'Sak Sampeou',
    code: '12414',
  },
  {
    name: 'Cheung Ek',
    code: '12415',
  },
];

export const ROLE_OPTIONS = {
  DRIVER: "Driver",
  SENDER: "Merchant",
  CALL_CENTER: "Call Center",
  OPERATION: "Operation",
  ACCOUNT: "Account",
  ADMIN:"Admin",
  SUPER_ADMIN: "Super Admin",
  CUSTOMER_SERVICE: "Customer Service"
};

export const ROLES = {
  DRIVER: "DRIVER",
  SENDER: "SENDER",
  CALL_CENTER: "CALL_CENTER",
  CUSTOMER_SERVICE: "CUSTOMER_SERVICE",
  OPERATION: "OPERATION",
  ACCOUNT: "ACCOUNT",
  ADMIN:"ADMIN",
  SUPER_ADMIN:"SUPER_ADMIN",
};

export const VEHICLE_TYPE_OPTION = [
  { value: 'Motor', label: 'Motor' },
  { value: 'Tuk Tuk', label: 'Tuk Tuk' },
];

export { INVOICES_TYPE, STATUSES };
export default STATUSES;

export const statusImportDeliverOrderFilterOptions = [
  {
    label: DELIVERY_ORDER_STATUS.REQUESTED,
    value: DELIVERY_ORDER_STATUS.REQUESTED,
  },
  {
    label: DELIVERY_ORDER_STATUS.APPOINTED,
    value: DELIVERY_ORDER_STATUS.APPOINTED,
  }
]